<div [class]="class" [style.height.px]="iconHeight" [style.width.rem]="iconWidth" [style.padding]="iconPadding">
  <!-- Place content of component tag here -->
  <ng-content></ng-content>
</div>
